import { faCalendar } from "@jewlr/pro-light-svg-icons/faCalendar"
import { faShippingFast } from "@jewlr/pro-light-svg-icons/faShippingFast"
import { Box, Flex, FontAwesomeIcon, Typography } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import styled from "styled-components"

import ProgressBar from "areas/account/order/progress"

const Icon = styled(FontAwesomeIcon)`
  display: block;
  font-size: 18px;
  margin-right: 8px;
  ${(props) => props.theme.mediaQueries.tablet`
    margin-bottom: 10px;
    margin-right: 0;
  `}
`

const Status = styled(Typography).attrs({
  as: "span",
})`
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
`

const Date = styled(Typography)`
  font-size: 16px;
  font-weight: 300;
  letter-spacing: -0.02em;
  line-height: 22px;
`

const Progress = ({ data }) => {
  return (
    <>
      <Flex
        flexDirection={{ _: "column", tablet: "row" }}
        justifyContent="space-between"
        mb={{ tablet: "10px" }}
        mt={{ _: 5, tablet: 0 }}
      >
        <Flex
          flexDirection={{ _: "row", tablet: "column" }}
          mb={{ _: 3, tablet: 0 }}
        >
          <Icon icon={faCalendar} />
          <Box>
            <Status>Order Date:</Status>
            <Date>{data.order_date}</Date>
          </Box>
        </Flex>
        <Flex
          alignItems={{ tablet: "flex-end" }}
          flexDirection={{ _: "row", tablet: "column" }}
          mb={{ _: 3, tablet: 0 }}
        >
          <Icon icon={faShippingFast} />
          <Box textAlign={{ tablet: "right" }}>
            <Status>Estimated Delivery Date:</Status>
            <Date>{data.estimated_delivery_date}</Date>
          </Box>
        </Flex>
      </Flex>
      <ProgressBar customerState={data.customer_progress} />
    </>
  )
}

Progress.propTypes = {
  data: PropTypes.object,
}

export default Progress
